import { Component, OnInit } from '@angular/core';
import { IdentityService } from '../services/identity.service'
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html'
})
export class ActivateComponent implements OnInit {
  activated: boolean = null;

  constructor(private identityService : IdentityService) { }

  async ngOnInit() {
    const user = await this.identityService.getIdentity();
    const verified= user
      && user.email
      && user.emailVerified;
    console.log(`User activated. Checking email verification state: ${verified}`, user);
    if (verified){
      console.log("user has verified email. Updating roles.");
      const updateMyRoles = firebase.functions().httpsCallable("updateMyRoles");
      await updateMyRoles();
      console.log("user roles updated");
      user.getIdToken(true);
      this.activated = true;
    }
  }
}
